<template>
    <DModal
        v-model="activity_log_comment"
        :show="showModal"
        :title="__('customers.terminations.withdrawal_confirm_title')"
        :message="__('customers.terminations.withdrawal_confirm_message')"
        is-confirm
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        is-error
        :show-incident-list="true"
        :customer-id="contract?.customer_id ?? 0"
        @setIncident="setIncident"
        @update:show="$emit('update:showModal', $event)"
        @confirm="withdrawContractConfirm"
        @close="$emit('close-modal')"
    />
</template>

<script>
export default {
    name: 'WithdrawContractModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        redirectTo: {
            type: String,
            default: 'contract-list'
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            activity_log_comment: '',
            incident_id: null
        }
    },
    methods: {
        withdrawContractConfirm () {
            this.$inertia.post(this.$route('customers.customers.contracts.withdraw-contract', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                redirectTo: this.redirectTo,
                activity_log_comment: this.activity_log_comment,
                filters: this.filters,
                incident_id: this.incident_id
            }),
            {},
            {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        },
        setIncident (value) {
            this.incident_id = value
        }
    }
}
</script>
